<template>
  <span :class="['badge', statusClass]">{{ statusText }}</span>
</template>

<script>
export default {
  props: {
    substitution: {
      type: Object,
      required: true,
    },
  },

  computed: {
    statusText() {
      if (this.substitution.rejected) {
        return "Refusée";
      } else if (this.substitution.treated) {
        return "Validée";
      } else {
        return "A traiter";
      }
    },

    statusClass() {
      if (this.substitution.rejected) {
        return "badge-danger";
      } else if (this.substitution.treated) {
        return "badge-success";
      } else {
        return "badge-info";
      }
    },
  },
};
</script>
